import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

/** @type {boolean} */
const initialState = false;

/** @returns {true} */
const isLoading = () => true;

/** @returns {false} */
const isEnding = () => false;

export default createReducer(initialState, {
  [types.FETCH_CHAT_STATISTICS_REQUEST]: isLoading,
  [types.FETCH_CHAT_STATISTICS_SUCCESS]: isEnding,
  [types.FETCH_CHAT_STATISTICS_FAILURE]: isEnding,
});
